
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const MobileSearch = () => {
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  
  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/explore?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
      setSearchOpen(false);
    }
  };

  return (
    <>
      {searchOpen ? (
        <form 
          onSubmit={handleSearchSubmit} 
          className="absolute inset-0 flex items-center bg-background px-4 h-16 z-50 animate-in slide-in-from-top"
        >
          <input
            type="text"
            placeholder="Search papers..."
            className="h-10 flex-1 rounded-l-full bg-secondary/80 pl-4 pr-4 text-sm focus:outline-none border border-input"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            autoFocus
          />
          <Button type="submit" size="sm" className="h-10 rounded-r-full">
            Search
          </Button>
          <Button 
            type="button" 
            variant="ghost" 
            size="icon" 
            className="ml-2" 
            onClick={() => setSearchOpen(false)}
          >
            <X className="h-5 w-5" />
          </Button>
        </form>
      ) : (
        <Button 
          size="icon" 
          variant="ghost" 
          className="text-foreground/80"
          onClick={() => setSearchOpen(true)}
        >
          <Search className="h-5 w-5" />
        </Button>
      )}
    </>
  );
};

export default MobileSearch;
